import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./index.scss";

const p2 = (content: any) => {
  return <p className="title-two">{content}</p>;
};

const Ayuda = () => {
  return (
    <div className="ayuda-container">
      <Header variant="dark" />
      <div className="content">
      <p className="title-one">Preguntas Frecuentes</p>
      <br />
      {p2("¿Cuáles son los requisitos para solicitar un préstamo?")}
      <p>
        Los requisitos para solicitar un préstamo generalmente incluyen: el
        solicitante debe tener al menos 18 años, tener una fuente de ingresos
        estable, contar con un historial crediticio favorable y proporcionar una
        identificación válida.
      </p>
      <br />
      {p2("¿Cómo solicitar un préstamo?")}
      <p>
        Descarga la aplicación de préstamos, regístrate, completa tu información
        personal y los detalles del préstamo, envía la solicitud y espera los
        resultados de la aprobación.
      </p>
      <br />
      {p2("¿Por qué razones podría no aprobarse mi solicitud?")}
      <p>
        Algunos motivos comunes son: historial crediticio negativo, ingresos
        insuficientes, o datos incompletos o erróneos en la solicitud.
      </p>
      <br />
      {p2("¿Cuál es el monto mínimo y máximo que puedo solicitar?")}
      <p>
        El monto depende del producto financiero disponible y tu perfil de
        usuario.
      </p>
      <br />
      {p2("¿En cuánto tiempo recibiré el dinero?")}
      <p>
        Una vez aprobado el préstamo, recibirás el dinero en tu cuenta en pocos
        minutos.
      </p>
      <br />
      {p2("¿Cuál es la tasa de interés?")}
      <p>
        La tasa de interés varía según tu perfil y el monto solicitado. Puedes
        consultarla antes de confirmar tu préstamo.
      </p>
      <br />
      {p2("¿Hay comisiones o costos adicionales?")}
      <p>
        No. Todos los costos se muestran de forma clara antes de confirmar el
        préstamo.
      </p>
      <br />

      {p2("¿Cómo sabré si mi préstamo fue aprobado?")}
      <p>
        Recibirás una notificación en la app y por SMS o correo electrónico.
      </p>
      <br />

      {p2("¿Puedo pagar antes de la fecha de vencimiento?")}
      <p>
        Sí. Puedes hacer un pago anticipado en cualquier momento sin
        penalización.
      </p>
      <br />

      {p2("¿Qué pasa si me atraso en el pago?")}
      <p>
        Se generarán intereses moratorios y podrías tener restricciones para
        futuros préstamos.
      </p>
      <br />

      {p2("¿Puedo tener más de un préstamo activo?")}
      <p>No. Solo puedes tener un préstamo activo a la vez.</p>
      <br />

      {p2("¿Puedo solicitar otro préstamo después de pagar uno?")}
      <p>
        Sí. Una vez pagado el préstamo anterior, puedes solicitar uno nuevo
        inmediatamente.
      </p>
      <br />

      {p2("¿Por qué fue rechazada mi solicitud?")}
      <p>
        Puede deberse a información incompleta, errores en tus datos o historial
        de pago. Te recomendamos revisar y volver a intentarlo.
      </p>
      <br />

      {p2("¿Cuáles son los requisitos para solicitar un préstamo?")}
      <p>
        Los requisitos para solicitar un préstamo generalmente incluyen: el
        solicitante debe tener al menos 18 años, tener una fuente de ingresos
        estable, contar con un historial crediticio favorable y proporcionar una
        identificación válida.
      </p>
      <br />

      {p2("¿Cómo solicitar un préstamo?")}
      <p>
        Descarga la aplicación de préstamos, regístrate, completa tu información
        personal y los detalles del préstamo, envía la solicitud y espera los
        resultados de la aprobación.
      </p>
      <br />

      {p2("¿Cuánto tiempo tarda la aprobación del préstamo?")}
      <p>
        El tiempo de aprobación de un préstamo suele ser de unos minutos a
        varios días laborables, dependiendo del proceso de revisión de la
        plataforma y de la integridad de los documentos presentados.
      </p>
      <br />

      {p2("¿Cuál es la tasa de interés del préstamo?")}
      <p>
        La tasa de interés varía según la puntuación crediticia del usuario y el
        producto de préstamo seleccionado. La plataforma informará claramente la
        tasa de interés al momento de la solicitud.
      </p>
      <br />

      {p2(
        "¿Cuáles son las razones comunes por las que no se aprueba un préstamo?"
      )}
      <p>
        Las razones comunes para no aprobar un préstamo incluyen: mal historial
        crediticio, ingresos insuficientes, documentación incompleta o
        información incorrecta. Se recomienda que los solicitantes aseguren que
        la información sea precisa y trabajen para mejorar su puntuación
        crediticia.
      </p>
      <br />

      {p2("¿Se cobrará una multa por pago atrasado?")}
      <p>
        Sí, los pagos atrasados generalmente incurrirán en cargos por mora o
        intereses de penalización. El monto específico depende del número de
        días de atraso y el monto del préstamo.
      </p>
      <br />
      {p2(
        "¿Se puede volver a solicitar un préstamo si la solicitud es rechazada?"
      )}
      <p>
        Sí, después de un rechazo, generalmente puedes volver a solicitar un
        préstamo después de 7 días. Sin embargo, se recomienda entender la razón
        del rechazo y realizar los ajustes necesarios, como mejorar el crédito o
        proporcionar documentación adicional.
      </p>
      <br />

      {p2("¿Cómo puedo cancelar mi cuenta?")}
      <p>
        Si desea cancelar su cuenta en la aplicación, puede hacerlo siguiendo
        estos pasos: Envíe un correo electrónico a nuestro equipo de atención al
        cliente a la dirección comercial@trustigo-ar.com, indicando su deseo de
        cancelar la cuenta.
      </p>
      <p>
        Para garantizar la seguridad del proceso, le pedimos que incluya la
        siguiente información en su mensaje:
      </p>
      <p>
        a. El número de teléfono o correo electrónico que utilizó para
        registrarse.
      </p>
      <p>b. (Opcional) El motivo por el cual desea cancelar la cuenta.</p>
      <p>
        c. Información para verificar su identidad (si fuera necesario,
        podríamos contactarle para confirmar la solicitud) Procesaremos su
        solicitud tan pronto como la recibamos y completaremos la cancelación de
        su cuenta dentro de un plazo máximo de 7 días hábiles.
      </p>
      <p>
        Durante este tiempo, si tiene alguna consulta adicional, nuestro equipo
        estará disponible para asistirle. Agradecemos su paciencia y
        colaboración.
      </p>
      <br />
    </div>
      <Footer />
    </div>
  );
};

export default Ayuda;
